// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1v0yI","loginBlock":"Header_loginBlock__3g_eP","button":"Header_button__2M-9a","headerTheme":"Header_headerTheme__IF9fD"};